import React, { useState } from "react";

const EmpQualificationDetails = ({ data, setData, errors = {} }) => {
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
    };


  return (
    <>
      <div className="row g-3">

        {/* SSLC School */}
        <div className="col-lg-4">
          <label className="form-label">
            SSLC School Name <span className="danger">*</span>
          </label>
          <input
            name="sslcschool"
            className="form-control"
            value={data.sslcschool || ""}
            onChange={handleChange}
          />
          {errors.sslcschool && (
            <small className="error-text">{errors.sslcschool}</small>
          )}
        </div>

        {/* SSLC Year */}
      

        {/* UG Degree */}
        <div className="col-lg-4">
          <label className="form-label">
            UG Degree <span className="danger">*</span>
          </label>
          <input
            name="ugdegree"
            className="form-control"
            value={data.ugdegree || ""}
            onChange={handleChange}
          />
          {errors.ugdegree && (
            <small className="error-text">{errors.ugdegree}</small>
          )}
        </div>

     

        {/* PG Degree */}
        <div className="col-lg-4">
          <label className="form-label">
            PG Degree <span className="danger">*</span>
          </label>
          <input
            name="pgdegree"
            className="form-control"
            value={data.pgdegree || ""}
            onChange={handleChange}
          />
          {errors.pgdegree && (
            <small className="error-text">{errors.pgdegree}</small>
          )}
        </div>
          <div className="col-lg-4">
          <label className="form-label">
            SSLC Year of Passing <span className="danger">*</span>
          </label>
          <input
            type="number"
            name="sslcyearpass"
            className="form-control"
            placeholder="YYYY"
            min="1950"
            max={new Date().getFullYear()}
            value={data.sslcyearpass || ""}
            onChange={handleChange}
          />
          {errors.sslcyearpass && (
            <small className="error-text">{errors.sslcyearpass}</small>
          )}
        </div>

           {/* UG Stream */}
        <div className="col-lg-4">
          <label className="form-label">
            UG Stream <span className="danger">*</span>
          </label>
          <input
            name="ugstream"
            className="form-control"
            value={data.ugstream || ""}
            onChange={handleChange}
          />
          {errors.ugstream && (
            <small className="error-text">{errors.ugstream}</small>
          )}
        </div>

        {/* PG Stream */}
        <div className="col-lg-4">
          <label className="form-label">
            PG Stream <span className="danger">*</span>
          </label>
          <input
            name="pgstream"
            className="form-control"
            value={data.pgstream || ""}
            onChange={handleChange}
          />
          {errors.pgstream && (
            <small className="error-text">{errors.pgstream}</small>
          )}
        </div>
          <div className="col-lg-4">
          <label className="form-label">
            HSC School Name <span className="danger">*</span>
          </label>
          <input
            name="hscschoolname"
            className="form-control"
            value={data.hscschoolname || ""}
            onChange={handleChange}
          />
          {errors.hscschoolname && (
            <small className="error-text">{errors.hscschoolname}</small>
          )}
        </div>
            <div className="col-lg-4">
          <label className="form-label">
            UG Year of Passing <span className="danger">*</span>
          </label>
          <input
            type="number"
            name="ugyearpass"
            className="form-control"
            placeholder="YYYY"
            min="1950"
            max={new Date().getFullYear()}
            value={data.ugyearpass || ""}
            onChange={handleChange}
          />
          {errors.ugyearpass && (
            <small className="error-text">{errors.ugyearpass}</small>
          )}
        </div>
          <div className="col-lg-4">
          <label className="form-label">
            PG Year of Passing <span className="danger">*</span>
          </label>
          <input
            type="number"
            name="pgyearpass"
            className="form-control"
            placeholder="YYYY"
            min="1950"
            max={new Date().getFullYear()}
            value={data.pgyearpass || ""}
            onChange={handleChange}
          />
          {errors.pgyearpass && (
            <small className="error-text">{errors.pgyearpass}</small>
          )}
        </div>
         <div className="col-lg-4">
          <label className="form-label">
            HSC Year of Passing <span className="danger">*</span>
          </label>
          <input
            type="number"
            name="hscyearpass"
            className="form-control"
            placeholder="YYYY"
            min="1950"
            max={new Date().getFullYear()}
            value={data.hscyearpass || ""}
            onChange={handleChange}
          />
          {errors.hscyearpass && (
            <small className="error-text">{errors.hscyearpass}</small>
          )}
        </div>
          <div className="col-lg-4">
          <label className="form-label">
            UG CGPA <span className="danger">*</span>
          </label>
          <input
            name="ugcgpa"
            className="form-control"
            value={data.ugcgpa || ""}
            onChange={handleChange}
          />
          {errors.ugcgpa && (
            <small className="error-text">{errors.ugcgpa}</small>
          )}
        </div>
          <div className="col-lg-4">
          <label className="form-label">
            PG CGPA <span className="danger">*</span>
          </label>
          <input
            name="pgcgpa"
            className="form-control"
            value={data.pgcgpa || ""}
            onChange={handleChange}
          />
          {errors.pgcgpa && (
            <small className="error-text">{errors.pgcgpa}</small>
          )}
        </div>
        

      </div>

      
      </>
  );
};

export default EmpQualificationDetails;
